import { render } from "./SeoRef.vue?vue&type=template&id=5b645d2f&scoped=true"
import script from "./SeoRef.vue?vue&type=script&lang=js"
export * from "./SeoRef.vue?vue&type=script&lang=js"

import "./SeoRef.vue?vue&type=style&index=0&id=5b645d2f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b645d2f"]])

export default __exports__